import React from 'react'
import { Helmet } from 'react-helmet'
import { Jumbotron } from 'reactstrap'

const NotFound = () =>
  <div>
    <Helmet>
      <title>OTC OMS | Page Not Found</title>
    </Helmet>
    <Jumbotron>
      <h1 className='text-center'>Page Not Found</h1>
    </Jumbotron>
  </div>

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js